import { ref } from "vue";
import ChatService from "../../../core/core/chat/ChatService";
import AiSubectData from "./ai/AiSubectData";
import Util from "../../../utils/Util";
import MindMe from "../../facade/MindMe";
import Config from "../../../core/core/calcule/Config";
import AiChatMessage from "./ai/AiChatMessage";
import AiMessageToMap from "./ai/AiMessageToMap";
if (
    typeof navigator === "object" &&
    typeof navigator.userAgent === "string" &&
    navigator.userAgent.indexOf("Electron") >= 0
) {
    var { ipcRenderer } = window.require("electron");

}

class ChatWindowVM {
    constructor(isElectron = true) {
        this.chatService = new ChatService(isElectron, 'https://todo.mindyushu.com');
        this.chatMessages = []
        this.messageIdPoint = -1
        this.loading = false;
        this.messages = ref([]);
        this.inputMessage = ref('');
        this.messagesContainer = ref(null);
        this.isStreaming = ref(false);
        this.isElectron = isElectron;
        this.deleagte;
        this.currentMessage = null;

        this.firstLevelSeparatedBy = "|";
        this.secondLevelSeparatedBy = "--";

        this.isTestData = false;
        this.valueIndex = 0;
    }

    sendChatMessageToAiForMap() {

    }

    loadData() {
        let markdown = "# 《红楼梦》大纲\n" +
                "\n" +
                "## 一、作品概况\n" +
                "- **作品名称**：《红楼梦》（又名《石头记》《金陵十二钗》《风月宝鉴》）\n" +
                "- **作者**：曹雪芹（前80回），高鹗（续写后40回，存争议）\n" +
                "- **成书年代**：清代乾隆年间（18世纪中叶）\n" +
                "- **文学地位**：中国古典小说巅峰之作，“中国封建社会的百科全书”\n" +
                "\n" +
                "## 二、核心主线\n" +
                "\n" +
                "### 1. **神话框架**\n" +
                "- **女娲补天遗石**：通灵宝玉的由来\n" +
                "- **绛珠仙草还泪**：宝黛前世情缘（神瑛侍者与绛珠仙草）\n" +
                "- **太虚幻境**：金陵十二钗命运判词\n" +
                "\n" +
                "### 2. **现实主线**\n" +
                "- **贾府兴衰史**：钟鸣鼎食之家 → 衰败抄家 → “白茫茫大地真干净”\n" +
                "- **宝黛钗爱情悲剧**：木石前盟 vs 金玉良缘\n" +
                "- **大观园女儿命运**：千红一哭，万艳同悲\n" +
                "\n" +
                "## 三、主要人物关系\n" +
                "\n" +
                "### **贾府主要人物**\n" +
                "```\n" +
                "荣国府：\n" +
                "贾母（史太君）—— 最高家长\n" +
                "├─贾赦（长子）—邢夫人\n" +
                "│   ├─贾琏—王熙凤\n" +
                "│   │   └─巧姐\n" +
                "│   └─迎春（二小姐）\n" +
                "├─贾政（次子）—王夫人\n" +
                "│   ├─贾珠（早逝）—李纨\n" +
                "│   │   └─贾兰\n" +
                "│   ├─元春（大小姐，皇妃）\n" +
                "│   ├─宝玉（男主角）\n" +
                "│   └─探春（三小姐）\n" +
                "└─贾敏（女儿，已故）—林如海\n" +
                "    └─林黛玉（女主角）\n" +
                "\n" +
                "宁国府：\n" +
                "贾敬→贾珍—尤氏\n" +
                "    ├─贾蓉—秦可卿\n" +
                "    └─惜春（四小姐）\n" +
                "```\n" +
                "\n" +
                "### **关键人物**\n" +
                "- **贾宝玉**：叛逆贵族，核心视角人物\n" +
                "- **林黛玉**：孤高才女，宝玉知己\n" +
                "- **薛宝钗**：端庄贤淑，传统闺秀\n" +
                "- **王熙凤**：精明管家，权势女性\n" +
                "- **史湘云**：豪爽才女\n" +
                "- **妙玉**：带发修行的官家小姐\n" +
                "- **袭人、晴雯**：重要丫鬟\n" +
                "\n" +
                "## 四、情节结构（120回概要）\n" +
                "\n" +
                "### **第一部分：繁荣鼎盛（第1-54回）**\n" +
                "- **序幕**：甄士隐与贾雨村，通灵宝玉入世\n" +
                "- **黛玉进府**：宝黛初见，似曾相识\n" +
                "- **薛家入京**：宝钗登场，“金玉良缘”伏笔\n" +
                "- **秦可卿之死**：盛大丧礼，王熙凤协理宁国府\n" +
                "- **元春省亲**：修建大观园，贾府巅峰时刻\n" +
                "- **群芳入住大观园**：诗社活动，青春乐园\n" +
                "\n" +
                "### **第二部分：暗流涌动（第55-80回）**\n" +
                "- **探春理家**：改革尝试，难挽颓势\n" +
                "- **矛盾激化**：\n" +
                "  - 王熙凤逼死尤二姐\n" +
                "  - 抄检大观园（转折点）\n" +
                "  - 晴雯被逐病死\n" +
                "- **悲情深化**：黛玉《葬花吟》，宝黛情感考验\n" +
                "- **贾府危机**：经济窘迫，内部矛盾加剧\n" +
                "\n" +
                "### **第三部分：衰败崩塌（第81-120回，含续书）**\n" +
                "- **宝玉失玉**：精神失常\n" +
                "- **调包计**：宝玉娶宝钗，黛玉焚稿断情\n" +
                "- **贾府被抄**：政治清算，树倒猢狲散\n" +
                "- **结局**：\n" +
                "  - 宝玉中举后出家\n" +
                "  - 宝钗守寡\n" +
                "  - 巧姐被救\n" +
                "  - “食尽鸟投林”\n" +
                "\n" +
                "## 五、核心主题\n" +
                "\n" +
                "### 1. **爱情悲剧**\n" +
                "- 木石前盟（宝黛）的纯粹与破灭\n" +
                "- 金玉良缘（宝玉宝钗）的世俗婚姻\n" +
                "\n" +
                "### 2. **家族兴衰**\n" +
                "- 封建贵族家庭由盛转衰的必然性\n" +
                "- “眼看他起朱楼，眼看他宴宾客，眼看他楼塌了, 眼看他起朱楼，眼看他宴宾客，眼看他楼塌了, 眼看他起朱楼，眼看他宴宾客，眼看他楼塌了”\n" +
                "\n" +
                "### 3. **女性命运**\n" +
                "- 金陵十二钗的多元女性形象\n" +
                "- 封建社会中女性的困境与挣扎\n" +
                "\n" +
                "### 4. **人生哲思**\n" +
                "- “真”与“假”的辩证（甄士隐、贾雨村）\n" +
                "- 富贵如云烟，人生如梦\n" +
                "- 反科举、反封建的叛逆思想\n" +
                "\n" +
                "## 六、艺术特色\n" +
                "\n" +
                "### **结构艺术**\n" +
                "- 网状结构，草蛇灰线\n" +
                "- 神话与现实双线交织\n" +
                "- 前80回伏笔千里，后40回争议不断\n" +
                "\n" +
                "### **人物塑造**\n" +
                "- “千人千面”，打破脸谱化\n" +
                "- 心理描写细腻\n" +
                "- 人物诗词个性化\n" +
                "\n" +
                "### **语言成就**\n" +
                "- 京白与诗语的完美融合\n" +
                "- 对话高度个性化\n" +
                "- 大量诗词、灯谜、酒令\n";
        let hssMD =  "《寒山诗》是唐代诗僧寒山（又名寒山子）创作的白话诗集合，以其语言通俗、禅意深邃而闻名。以下是整理与解读：---\n" +
                "### **一、寒山其人**\n" +
                "寒山（约7-8世纪），唐代隐士、诗僧，长期隐居浙江天台山寒岩。其身世神秘，据传曾为官宦子弟，后出家修行，与僧侣拾得、丰干交好。诗中常以“寒山”自称，语言风格俚俗直白，融合佛道思想，展现自然隐逸与禅悟境界。\n" +
                "---\n" +
                "### **二、诗歌主题与内容**\n" +
                "1. **自然山水与隐逸生活**  寒山诗多描绘天台山景致与隐居之乐，体现超脱尘世的情怀。  \n" +
                "   **例诗**：     > 杳杳寒山道，落落冷涧滨。   > 啾啾常有鸟，寂寂更无人。  \n" +
                "   *解读*：以叠词勾勒幽深清冷的山景，传递孤独却自在的隐者心境。\n" +
                "2. **佛法禅理与人生感悟**     诗中含有大量佛教因果、无常观，劝人向善、看破红尘。  \n" +
                "   **例诗**：     > 人生在尘蒙，恰似盆中虫。  \n" +
                "   > 终日行绕绕，不离其盆中。     *解读*：以盆中虫喻世人沉迷名利不得解脱，讽刺愚痴执着。\n" +
                "3. **社会批判与世态讽刺**  寒山诗批判世俗虚荣、贪婪，语言犀利如白话警句。   **例诗**：     > 富者多悭贪，施者常贫贱。     > 不信但看筵中酒，杯杯先劝有钱人。     *解读*：直指社会势利与财富不均，暗含因果报应思想。\n" +
                "4. **自述心性与修行体验**     诗中常见对自我身份、修行境界的描写，洒脱不羁。  \n" +
                "   **例诗**：     > 时人见寒山，各谓是风颠。  \n" +
                "   > 貌不起人目，身唯布裘缠。  \n" +
                "   *解读*：以“疯癫”形象自喻，表达超越世俗标准的自在境界。\n" +
                "---\n" +
                "### **三、艺术特色**\n" +
                "1. **语言风格**  \n" +
                "   - 白话俚语入诗，浅显直白，类似口语谚语。  \n" +
                "   - 善用叠词、比喻、对比（如“富者”vs“施者”），增强讽刺与禅悟效果。2. **意象运用**  \n" +
                "   - 自然意象：寒山、明月、白云、松柏（象征高洁与永恒）。   - 宗教意象：莲花、轮回、因果（融合佛道思想）。\n" +
                "3. **思想境界**     融合儒家劝世、道家逍遥与佛家空观，形成独特的“寒山体”，影响后世禅诗与日本俳句。\n" +
                "---\n" +
                "### **四、经典选读**1. **《吾心似秋月》**  \n" +
                "   > 吾心似秋月，碧潭清皎洁。  \n" +
                "   > 无物堪比伦，教我如何说。  \n" +
                "   *解读*：以秋月碧潭喻心性澄明，表达不可言说的禅悟境界。\n" +
                "2. **《欲得安身处》**   > 欲得安身处，寒山可长保。  \n" +
                "   > 微风吹幽松，近听声愈好。  \n" +
                "   *解读*：隐居寒山时聆听松涛，体现身心与自然合一的安宁。\n" +
                "---\n" +
                "### **五、历史影响**\n" +
                "- **国内**：宋代以后被禅宗推崇，王梵志、拾得等诗人受其影响。  \n" +
                "- **国际**：20世纪传入欧美，成为“垮掉的一代”（如杰克·凯鲁亚克）的精神符号，象征反世俗与自由追求。\n" +
                "---\n" +
                "### **六、参考版本**\n" +
                "- 《寒山诗注》（项楚注，中华书局）：权威校注本，详解典故与佛理。  - 《寒山子诗集》（四部丛刊本）：常见古籍版本。\n" +
                "寒山诗以通俗语言承载深刻哲思，既是唐代白话诗的典范，也是禅宗文化的重要遗产。"
        if (this.isTestData) {
            this.chatMessages.push(new AiChatMessage(0, "你好", true))
            this.chatMessages.push(new AiChatMessage(1, "你好！😊 很高兴为你服务。 \n如需任何帮助——无论是信息查询、数据分析、文档撰写，还是其他任务——请随时告诉我，我会全力支持你。 \n祝你今天在石家庄拥有高效而愉快的一天！🌤️", false))
            this.chatMessages.push(new AiChatMessage(4, "请给我整理、解释一下《寒山诗》古诗", true))
            this.chatMessages.push(new AiChatMessage(5, hssMD, false))
        }
       
        this.updateUiMessages(true);
    }

    updateUiMessages(isScrollToBottom = true) {
        if (this.deleagte != null) {
            this.deleagte.updateMessages(this.chatMessages, isScrollToBottom)
        }
    }

    addNewChatMessage(message) {
        if (message == null || message.length == 0) {
            this.deleagte.showError("消息不能为空") 
            return;
        }
        var currentList = this.chatMessages;
        if (currentList == null) {
            currentList = [];
            this.chatMessages = currentList
        }
        if (currentList.length != 0 && currentList[currentList.length - 1].isMine &&
                Math.abs(currentList[currentList.length - 1].createTime - Util.getCurrentTime()) < 5000) {
            return;
        }
        let newMessage = new AiChatMessage(this.newMessageId(), message, true);
        newMessage.setCompleted(true);
        newMessage.setCreateTime(Util.getCurrentTime() - 1);
        currentList.push(newMessage);
        this.updateUiMessages(true);
        // StorageManager.get().createAiChatMessage(newMessage);
    }

    addChatDialogueMessage(message, isCompleted) {
        if (this.isEmpty(message)) {            
            // errorMessage.setValue("消息不能为空");
            this.deleagte.showError("消息不能为空") 
            return;
        }

        let currentList = this.chatMessages;
        if (currentList == null) {
            currentList = [];
            this.chatMessages = currentList
        }
        if (currentList.length != 0 && !currentList[currentList.length - 1].isMine &&
                !currentList[currentList.length - 1].isCompleted && !isCompleted &&
                message == currentList[currentList.length - 1].message) {
            return;
        }
        if (currentList.length != 0 &&
                !currentList[currentList.length - 1].isMine &&
                !currentList[currentList.length - 1].isCompleted) {
            let dialogueMessage = currentList[currentList.length - 1];
            dialogueMessage.setMessage (message);
            dialogueMessage.setCompleted(isCompleted);
            this.updateUiMessages(true)
            // StorageManager.get().updateAiChatMessage(dialogueMessage);
        } else {
            let newMessage = new AiChatMessage(this.newMessageId(), message, false);
            newMessage.setCompleted(isCompleted);
            currentList.push(newMessage);
            this.updateUiMessages(true)
            // StorageManager.get().createAiChatMessage(newMessage);
        }
    }

    openMindMap(mindId) {
        if (this.deleagte.$tools.isElectron()) {
            ipcRenderer.send("openCalendarWindow", "/mindmap?id=" + mindId);
        } else {
            const routerData = this.deleagte.$router.resolve({
                path: "/mindmap",
                query: {
                    id: mindId,
                },
            });
            this.createATagJump(routerData.href);
        }
    }

    onFormatCompleted(isOk, mindId) {
        if (!isOk) {
            return
        }
        this.deleagte.showMessage("转化成功, 文件放入【最近创作】项") 
        if (this.currentMessage) {            
            this.currentMessage.setMindId(2);
            this.currentMessage.setMindServerId(mindId);
        }
        // StorageManager.get().updateAiChatMessage(currentMessage);
        this.updateUiMessages(false);
        setTimeout(() => {
            this.openMindMap(mindId)
        }, 300);
    }
    
    error(message) {
        // console.log(message); 
        this.deleagte.showError(message)       
    }

    messageToMap(message, isCompleted) {
        if (message.length == 0 || !isCompleted || this.currentMessage == null) {
            // console.log("tomap---->", message, isCompleted, this.currentMessage);            
            return;
        }
        new AiMessageToMap(message).format(this);
        this.loading = false;
        this.isStreaming.value = false;
    }

    sendMessageToAiForMap(message) {
        if (this.isEmpty(message)) {
            this.deleagte.showError("消息不能为空") 
            return;
        }
        if (message.length > 5000) {
            this.deleagte.showError("内容超过5000字，超出限制") 
            return;
        }
        let currentList = this.chatMessages;
        if (currentList == null) {
            currentList = [];
        }

        let newMessage = new AiChatMessage(this.newMessageId(), message, false);
        newMessage.setCompleted(true);
        newMessage.setMindId(-2);
        currentList.push(newMessage);
        this.updateUiMessages(true)
        // StorageManager.get().createAiChatMessage(newMessage);
        setTimeout(() => {
            this.sendChatMessageToAiForMap(newMessage);
        }, 500);
    }

    sendChatMessageToAiForMap(message) {
        let currentList = this.chatMessages;
        if (currentList != null) {
            let isFound = false;
            for (let index = 0; index < currentList.length; index++) {
                let cell = currentList[index]
                if (cell.id == message.id) {
                    this.currentMessage = cell;
                    isFound = true;
                    break;
                }
            }
            if (!isFound) {
                this.currentMessage = message.copy();
            }
        } else {
            this.currentMessage = message.copy();
        }
        let chatMessage = "请将下方的内容，帮我转化为思维导图，其中中心主题控制在10个字以内，主题控制在12个字以内，子主题控制的20个字以内，" +
                "每一个内容都是一个独立主题，行末需要换行，" +
                "中心主题字用{}包裹，主题用[]包裹，子主题用()包裹。层级关系用-表示（比如中心主题下的主题前-[xx], 主题下的子主题前--(xx), 子主题下的子主题前---(xx)等），" +
                "子主题的层级深度根据内容扩充，返回纯文本格式，方便后续代码分割处理和使用。\n" + "「" + message.message + "」";
        this.sendMessage(chatMessage, "deepseek-v3.1", true);
    }

    deleteChatMessage(id) {
        if (this.chatMessages != null) {
            for (let index = 0; index < this.chatMessages.length; index++) {
                let cell = this.chatMessages[index]
                if (cell.id == id) {
                    this.chatMessages.splice(index, 1)
                    break;
                }
            }
            this.updateUiMessages(false)
        }
    }

    newMessageId() {
        this.messageIdPoint += 1;
        return this.messageIdPoint;
    }

    isEmpty(str) {
        return str == null || str.length == 0;
    }

    setLoadingStatus() {
        // console.log("setLoadingStatus--> ", this.deleagte != null, this.loading);
        
        if (this.deleagte != null) {
            this.deleagte.setChatLoading(this.loading)
        }
    }

    sendMessage(message, model, isToMap) {
        // console.log("sendMessage-> ", this.loading);
        if (message.length > 5300) {
            this.deleagte.showError("内容超过5000字，超出限制") 
            return;
        }
        if (!message || this.loading) {
            return;
        }
        // 添加用户消息
        this.messages.value.push({
            role: 'user',
            content: message,
            timestamp: new Date(),
        });
        
        // 添加AI消息占位
        this.messages.value.push({
            role: 'assistant',
            content: '',
            timestamp: new Date(),
        });
        let that = this
        this.loading = true;
        this.isStreaming.value = true;
        this.setLoadingStatus()
        MindMe.useAiAddTimes()
        Config.lastUseAITime = Util.getCurrentTime()
        if (this.isTestData) {
            setTimeout(() => {
                if (isToMap) {
                    this.testToMap()
                } else {
                    this.testAddMessage()
                }
            }, 5000);
            return;
        }
        try {
            this.chatService.sendMessage({
                message,
                model: model,
                userId: "",
            },
            // 数据块回调
            (chunk) => {
                const lastIndex = that.messages.value.length - 1;
                that.messages.value[lastIndex].content += chunk;
                if (isToMap) {
                    that.messageToMap(that.messages.value[lastIndex].content, false);
                } else {
                    that.addChatDialogueMessage(that.messages.value[lastIndex].content, false);
                }
                // console.log('data chunk->', chunk);
                // console.log('data content->', that.messages.value[lastIndex].content);
            },
            // 完成回调
            () => {
                const lastIndex = that.messages.value.length - 1;
                if (isToMap) {
                    that.messageToMap(that.messages.value[lastIndex].content, true);
                } else {
                    that.addChatDialogueMessage(that.messages.value[lastIndex].content, true);
                }
                that.loading = false;
                that.isStreaming.value = false;                
                // console.log('completed content->', that.messages.value[lastIndex].content);
                that.setLoadingStatus()
            },
            // 错误回调
            (error) => {
                // console.error('Stream error:', error);
                var lastIndex = that.messages.value.length - 1;
                that.messages.value[lastIndex].content += `\n[错误: ${error.message}]`;
                if (isToMap) {
                    that.messageToMap(that.messages.value[lastIndex].content, true);
                } else {
                    that.addChatDialogueMessage(that.messages.value[lastIndex].content, true);
                }
                that.loading = false;
                that.isStreaming.value = false;
                that.setLoadingStatus()
            }
            );
        } catch (error) {
            // console.error('Request error:', error);
            if (error.name !== 'AbortError') {
                const lastIndex = that.messages.value.length - 1;
                that.messages.value[lastIndex].content = '请求失败，请重试。';

                if (isToMap) {
                    that.messageToMap(that.messages.value[lastIndex].content, true);
                } else {
                    that.addChatDialogueMessage(that.messages.value[lastIndex].content, true);
                }
            }
            that.loading = false;
            that.isStreaming.value = false;
            that.setLoadingStatus()
        } finally {
            that.loading = false;
            that.isStreaming.value = false;
            that.setLoadingStatus()
        }
  
    }

    testToMap() {
        let tst = "{XX电子产品营销方案}" +
        "-[执行摘要]\n" +
        "--(6个月销量目标与口碑建立)\n" +
        "--(核心定位都市精英健康效率)" +
        "-[市场分析]\n" +
        "--(目标市场)---(人口统计25-40岁中等收入)" +
        "---(地理一线新一线城市)\n" +
        "---(心理追求品质健康效率)\n" +
        "---(行为线上购物重视口碑)\n" +
        "--(竞争对手分析)\n" +
        "---(主要对手品牌产品列表)\n" +
        "---(对手优劣势对比分析)\n" +
        "---(市场机会独特卖点切入)\n" +
        "--(SWOT分析)\n" +
        "---(优势创新功能有竞争力定价)\n" +
        "---(劣势新品牌渠道不完善)\n" +
        "---(机会健康经济线上风口)\n" +
        "---(威胁巨头竞争技术迭代)" +
        "-[营销目标]" +
        "--(品牌目标3个月知名度30%)\n" +
        "--(销售目标6个月销量与金额)\n" +
        "--(用户目标真实用户好评率90%)\n" +
        "--(渠道目标入驻主流电商平台)" +
        "-[营销策略]" +
        "--(产品策略)" +
        "---(核心产品名称与功能)\n" +
        "---(增值服务延保App会员)\n" +
        "---(包装精美环保开箱体验)" +
        "--(价格策略)\n" +
        "---(渗透定价吸引早期用户)\n" +
        "---(最终售价建议零售价)\n" +
        "---(促销首发学生优惠价)\n" +
        "--(渠道策略)\n" +
        "---(线上天猫京东官网)\n" +
        "---(社交电商抖音小红书)\n" +
        "---(线下后期合作体验店)" +
        "--(推广策略)\n" +
        "---(预热期悬念海报KOL盲测)\n" +
        "---(发布期线上发布会媒体评测)\n" +
        "---(平台广告信息流精准投放)\n" +
        "---(电商推广首屏广告活动)\n" +
        "---(持续期内容运营技巧故事)\n" +
        "---(社群运营用户反馈忠诚度)\n" +
        "---(口碑营销种草奖励机制)\n" +
        "---(搜索引擎优化SEO_SEM)-[预算与资源分配]--(广告投放信息流KOL_SEM)\n" +
        "--(内容制作视频图文媒体合作)--(线上活动电商促销赠品)\n" +
        "--(公关活动发布会媒体关系)\n" +
        "--(应急储备5%预算灵活调整)]\n" +
        "--(第1-4周预热期悬念制造)\n" +
        "--(第5周发布会与广告启动)\n" +
        "--(第6-12周持续投放口碑运营)\n" +
        "--(第13-24周长期维护与优化)评估与监控]\n" +
        "--(KPI指标流量转化销售额)\n" +
        "--(品牌指标声量搜索量反馈)\n" +
        "--(监控工具电商后台GA统计)\n" +
        "--(社交媒体工具舆情监控)\n" +
        "--(调整机制每周复盘月度总结)--(敏捷营销快速优化策略)";
        let hssMap = "{寒山诗解读}" +
               "-[寒山其人]\n" +
               "--(唐代诗僧寒山子)\n" +
               "--(隐居浙江天台山寒岩)\n" +
               "--(身世神秘曾为官宦子弟)\n" +
               "-[诗歌主题与内容]\n" +
               "--(自然山水与隐逸生活)\n" +
               "---(描绘天台山景致隐居之乐)" +
               "---(例诗杳杳寒山道落落冷涧滨)" +
               "--(佛法禅理与人生感悟)\n" +
               "---(蕴含佛教因果无常观)\n" +
               "---(例诗人生在尘蒙似盆中虫)\n" +
               "--(社会批判与世态讽刺)\n" +
               "---(批判世俗虚荣贪婪)\n" +
               "---(例诗富者悭贪施者贫贱)\n" +
               "-[艺术特色]" +
               "--(语言风格)\n" +
               "---(白话俚语浅显直白)\n" +
               "---(善用叠词比喻对比)\n" +
               "--(意象运用)\n" +
               "---(自然意象寒山明月白云)\n" +
               "---(宗教意象莲花轮回因果)" +
               "--(思想境界)\n" +
               "---(融合儒道佛三家思想)\n" +
               "---(形成独特寒山体)\n" +
               "-[经典选读]\n" +
               "--(《吾心似秋月》)\n" +
               "---(吾心似秋月碧潭清皎洁)\n" +
               "---(喻心性澄明禅悟境界)" +
               "--(《欲得安身处》)\n" +
               "---(欲得安身处寒山可长保)\n" +
               "---(体现自然合一安宁)\n" +
               "-[历史影响]" +
               "--(国内被禅宗推崇)\n" +
               "--(影响王梵志拾得等)" +
               "--(国际传入欧美)\n" +
               "-[参考版本]\n" +
               "--(《寒山诗注》项楚注)\n" +
               "--(《寒山子诗集》四部丛刊本)";
        this.messageToMap(tst, true);
    }

    testAddMessage() {
        let messageStr = "{GRAI求职复盘}\n" +
                           "-[G目标回顾]\n" +
                           "--(当初设定的目标是什么)\n" +
                           "--(核心求职目标回顾)\n" +
                           "-[R结果评估]\n" +
                           "--(实际发生与目标差异)\n" +
                           "--(简历投递结果统计)\n" +
                           "--(面试完成情况评估)\n" +
                           "--(新机会与心态状态)\n" +
                           "-[A过程分析]\n" +
                           "--(成功之处与可复制经验)--(待改进问题与规避措施)\n" +
                           "--(简历匹配度问题分析)\n" +
                           "--(面试技巧不足分析)\n" +
                           "--(策略与精力管理问题)\n" +
                           "-[I总结与行动]\n" +
                           "--(核心经验教训提炼)\n" +
                           "--(具体行动计划制定)\n" +
                           "--(简历优化专项行动)\n" +
                           "--(面试问答库建设计划)\n" +
                           "--(投递策略调整方案)\n" +
                           "--(高质量问题准备计划)\n" +
                           "--(心态调整与长期规划)";
        var point = 0;
        let that = this
        let testAddMessageInterval = setInterval(() => {
            let end = point + 5;
            if (end > messageStr.length) {
                end = messageStr.length
            }
            point = end
            let value = messageStr.substring(0, end)
            that.addChatDialogueMessage(value, point >= messageStr.length);
            if (point >= messageStr.length) {
                that.loading = false;
                that.isStreaming.value = false;     
                that.setLoadingStatus()
                clearInterval(testAddMessageInterval);
            }            
        }, 200);
    }

    createATagJump(url) {
        const a = document.createElement('a');//创建a标签浏览器不会阻止弹出窗口
        a.setAttribute('href', url);
        a.setAttribute('target', '_blank');
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
        }, 5000);
    }

    clearDates() {
        this.chatMessages = []        
    }
}

export default new ChatWindowVM()